import { render, staticRenderFns } from "./SocratesExportPage.vue?vue&type=template&id=65797004"
import script from "./SocratesExportPage.vue?vue&type=script&lang=js"
export * from "./SocratesExportPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports